/*
 * Scoped border-box reset. As a drop-in component we can't assume the host app
 * has a global box-sizing reset, and several elements (e.g. the search input)
 * set width:100% alongside padding — without this they'd overflow their box.
 */
.base,
.base *,
.base *::before,
.base *::after {
  box-sizing: border-box;
}

.base {
  min-height: 100%;
  background: var(--ps-bg-base);
  color: var(--ps-text-primary);
  font-family: var(--ps-font-sans);
  padding: 0 0 60px;
}

.status {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 60vh;
  color: var(--ps-text-muted);
  font-size: var(--ps-text-base);
}
